/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { Route, Redirect, Switch } from 'react-router-dom';
import Loadable from 'UIComponents/decorators/Loadable';
import { KNOWLEDGE_CATEGORY_EDIT, SERVICE_KNOWLEDGE_CUSTOM_DOMAIN_WRITE } from '../../constants/ScopesConstants';
import { ARTICLES_STATE_ROUTE, CHOOSE_TEMPLATE_ROUTE, INSIGHTS_DASHBOARD_ROUTE, ORGANIZE_ROUTE, TEMPLATE_EDITOR_ROUTE, TEMPLATE_EDITOR_STYLES_ROUTE, TEMPLATE_EDITOR_CONTENT_ROUTE, EDIT_ARTICLE_ROUTE, INSIGHTS_ARTICLE_ROUTE, ARTICLES_ROUTE, INSIGHTS_ARTICLE_PERFORMANCE_ROUTE, INSIGHTS_ARTICLE_PUBLISHED_ROUTE, TEMPLATE_TRANSLATE_MODAL_ROUTE, ROOT_KB_PATH, KB_ONBOARDING_PATH, ARTICLES_STATE_ROUTE_WITH_PARAM } from '../constants/RouteConstants';
import { STATES_PATHS } from '../../constants/StateConstants';
import LoadingPage from '../../components/utility/LoadingPage';
import ChooseTemplate from '../../containers/ChooseTemplate';
import TranslateTemplateModal from '../../containers/TranslateTemplateModal';
import { getScopes } from '../../selectors/auth';
import { useMemo } from 'react';
import Application from '../../containers/Application';
import NotFoundPage from './NotFoundPage';
import RedirectToDefaultKnowledgeBase from './RedirectToDefaultKnowledgeBase';
import StageKnowledgeBase from '../../containers/StageKnowledgeBase';
import MaybeShowZeroState from './MaybeShowZeroState';
import KBv3BetaTerms from './KBv3BetaTerms';
import { useAppSelector } from '../../utils/hooks';
import NewUserOnboardingTour from '../../tour/components/NewUserOnboardingTour';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_LOADABLE_DELAY = 300;
const makeLoadablePage = (loader, delay = DEFAULT_LOADABLE_DELAY) => Loadable({
  delay,
  loader,
  LoadingComponent: LoadingPage
});
const LoadableEditTinyMCE = makeLoadablePage(() => import( /* webpackChunkName: "editorTinyMCE" */'../../containers/edit/EditTinyMCE').then(m => m.default));
const LoadableTemplateEditor = makeLoadablePage(() => import( /* webpackChunkName: "templateEditor" */'../../containers/TemplateEditor').then(m => m.default).catch(e => console.error(e)));
const LoadableSidebarContent = makeLoadablePage(() => import( /* webpackChunkName: "templateEditorSidebarContent" */'../../components/templateEditor/SidebarContent').then(m => m.default).catch(e => console.error(e)), 0);
const LoadableSidebarStyles = makeLoadablePage(() => import( /* webpackChunkName: "templateEditorSidebarStyles" */'../../components/templateEditor/SidebarStyles').then(m => m.default), 0);
const LoadableManage = makeLoadablePage(() => import( /* webpackChunkName: "manage" */'../../containers/Manage').then(m => m.default));
const LoadableDashboard = makeLoadablePage(() => import( /* webpackChunkName: "insights" */'../../containers/insights/Dashboard').then(m => m.default));
const LoadableArticleDetailsPerformance = makeLoadablePage(() => import( /* webpackChunkName: "articleDetailsPerformance" */'../../containers/insights/articlePerformance/ArticleDetailsPerformance').then(m => m.default));
const LoadableArticleDetails = makeLoadablePage(() => import( /* webpackChunkName: "articleDetails" */'../../containers/insights/articlePerformance/ArticleDetails').then(m => m.default));
const LoadableArticleDetailsPublished = makeLoadablePage(() => import( /* webpackChunkName: "articleDetails" */'../../containers/insights/articlePerformance/ArticlePublished').then(m => m.default));
const LoadableOrganize = makeLoadablePage(() => import( /* webpackChunkName: "organize" */'../../containers/Organize').then(m => m.default));
const LoadableReportingData = makeLoadablePage(() =>
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'repo... Remove this comment to see the full error message
import( /* webpackChunkName: "reporting-data__main" */'reporting-data/main'));
const LoadableOnboarding = makeLoadablePage(() => import( /* webpackChunkName: "onboarding" */'../../onboarding/components/OnboardingRoute').then(m => m.default));
const Routes = () => {
  const scopes = useAppSelector(getScopes);
  const canAccessTemplateEditor = useMemo(() => scopes.includes(SERVICE_KNOWLEDGE_CUSTOM_DOMAIN_WRITE), [scopes]);
  const canEditCategories = useMemo(() => scopes.includes(KNOWLEDGE_CATEGORY_EDIT), [scopes]);
  return /*#__PURE__*/_jsx(Application, {
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        component: LoadableOnboarding,
        path: KB_ONBOARDING_PATH
      }), /*#__PURE__*/_jsx(Route, {
        exact: true,
        path: "/",
        children: /*#__PURE__*/_jsx(MaybeShowZeroState, {})
      }), /*#__PURE__*/_jsx(Route, {
        exact: true,
        path: "/beta",
        children: /*#__PURE__*/_jsx(KBv3BetaTerms, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: ROOT_KB_PATH,
        children: /*#__PURE__*/_jsx(StageKnowledgeBase, {
          children: /*#__PURE__*/_jsx(NewUserOnboardingTour, {
            children: /*#__PURE__*/_jsxs(Switch, {
              children: [/*#__PURE__*/_jsx(Redirect, {
                exact: true,
                from: ROOT_KB_PATH,
                to: `${ARTICLES_STATE_ROUTE}/all`
              }), /*#__PURE__*/_jsx(Route, {
                exact: true,
                render: () => {
                  LoadableReportingData.preload();
                  return /*#__PURE__*/_jsx(LoadableDashboard, {});
                },
                path: INSIGHTS_DASHBOARD_ROUTE
              }), /*#__PURE__*/_jsx(Route, {
                component: LoadableManage,
                path: ARTICLES_STATE_ROUTE_WITH_PARAM
              }), /*#__PURE__*/_jsx(Redirect, {
                from: ARTICLES_ROUTE,
                to: `${ARTICLES_STATE_ROUTE}/all`
              }), canEditCategories && /*#__PURE__*/_jsx(Route, {
                component: LoadableOrganize,
                path: ORGANIZE_ROUTE
              }), canAccessTemplateEditor && /*#__PURE__*/_jsx(Route, {
                component: ChooseTemplate,
                path: CHOOSE_TEMPLATE_ROUTE
              }), canAccessTemplateEditor && /*#__PURE__*/_jsx(Route, {
                path: TEMPLATE_EDITOR_ROUTE,
                children: /*#__PURE__*/_jsxs(Switch, {
                  children: [/*#__PURE__*/_jsx(Redirect, {
                    exact: true,
                    from: TEMPLATE_EDITOR_ROUTE,
                    to: TEMPLATE_EDITOR_CONTENT_ROUTE
                  }), /*#__PURE__*/_jsx(Route, {
                    path: [`${TEMPLATE_EDITOR_CONTENT_ROUTE}/:navItem?`, `${TEMPLATE_EDITOR_STYLES_ROUTE}/:navItem?`, TEMPLATE_TRANSLATE_MODAL_ROUTE],
                    children: /*#__PURE__*/_jsxs(LoadableTemplateEditor, {
                      children: [/*#__PURE__*/_jsx(Route, {
                        component: LoadableSidebarContent,
                        path: `${TEMPLATE_EDITOR_CONTENT_ROUTE}/:navItem?`
                      }), /*#__PURE__*/_jsx(Route, {
                        component: LoadableSidebarStyles,
                        path: `${TEMPLATE_EDITOR_STYLES_ROUTE}/:navItem?`
                      }), /*#__PURE__*/_jsx(Route, {
                        component: TranslateTemplateModal,
                        exact: true,
                        path: TEMPLATE_TRANSLATE_MODAL_ROUTE
                      })]
                    })
                  })]
                })
              }), /*#__PURE__*/_jsx(Route, {
                path: "*",
                children: /*#__PURE__*/_jsx(NotFoundPage, {})
              })]
            })
          })
        })
      }), /*#__PURE__*/_jsx(Redirect, {
        exact: true,
        from: INSIGHTS_ARTICLE_ROUTE,
        to: INSIGHTS_ARTICLE_PERFORMANCE_ROUTE
      }), /*#__PURE__*/_jsx(Route, {
        path: INSIGHTS_ARTICLE_ROUTE,
        children: /*#__PURE__*/_jsxs(LoadableArticleDetails, {
          children: [/*#__PURE__*/_jsx(Route, {
            exact: true,
            render: routeProps => {
              LoadableReportingData.preload();
              return /*#__PURE__*/_jsx(LoadableArticleDetailsPerformance, Object.assign({}, routeProps));
            },
            path: INSIGHTS_ARTICLE_PERFORMANCE_ROUTE
          }), /*#__PURE__*/_jsx(Route, {
            exact: true,
            component: LoadableArticleDetailsPublished,
            path: INSIGHTS_ARTICLE_PUBLISHED_ROUTE
          })]
        })
      }), /*#__PURE__*/_jsx(Route, {
        component: LoadableEditTinyMCE,
        path: EDIT_ARTICLE_ROUTE
      }), /*#__PURE__*/_jsx(Route, {
        path: "/insights/dashboard",
        children: /*#__PURE__*/_jsx(RedirectToDefaultKnowledgeBase, {
          from: "/insights/dashboard",
          to: INSIGHTS_DASHBOARD_ROUTE
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: `/articles/state/:state(${STATES_PATHS.join('|')})`,
        children: /*#__PURE__*/_jsx(RedirectToDefaultKnowledgeBase, {
          from: `/articles/state/:state(${STATES_PATHS.join('|')})`,
          to: `${ARTICLES_STATE_ROUTE}/:state(${STATES_PATHS.join('|')})`
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "*",
        children: /*#__PURE__*/_jsx(NotFoundPage, {})
      })]
    })
  });
};
export default Routes;